import { Component, OnInit } from '@angular/core';
import { GetCurrenciesService } from 'src/app/shared/product/components/currency/getCurrencies.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { StepOneBase } from '../../../../../../../shared/product/stepOne';
import { BASIC_FORM_TEMPLATE } from 'src/app/shared/constantProductTypeInfos';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-basic-step-one',
  templateUrl: './basic-step-one.component.html',
  styleUrls: ['./basic-step-one.component.scss'],
})
export class BasicStepOneComponent extends StepOneBase implements OnInit {
  isUpdate: boolean;

  constructor(
    protected getCurrencies: GetCurrenciesService,
    protected auth: AuthService,
    public translate: TranslateService,
    private languageService: LanguageService
  ) {
    super(getCurrencies, auth);
  }

  ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.createFormGroup();
    this.clearValidation();
    this.watchTaxValue();
  }

  private clearValidation() {
    Object.keys(this.stepForm.controls).forEach((controllerName) => {
      const control = this.stepForm.get(controllerName);
      control?.clearValidators();
    });
  }

  private watchTaxValue() {
    this.stepForm.controls['TaxesQuestion'].valueChanges.subscribe((value) => {
      this.isTaxesApplied = value;
      if (this.isTaxesApplied) {
        this.stepForm.controls['Taxes'].setValue(1);
      }
    });
  }

  private createFormGroup() {
    this.productName = BASIC_FORM_TEMPLATE.PRODUCT_NAME;
    this.form = this.getForm(this.productName);
    this.stepForm = this.formValidator.createForm(this.form);
    this.stepForm.markAsUntouched();
  }
}
